import { Access, License, SystemConfig, UserLoginRedirectConfig, Language, Users } from '@/utils/api';
import { baseUrl } from "@/utils/env";

const actions = {
  checkToken: async (context) => {
    let isUseToken = false;
    if (!context.getters.token) return
    await Access.CheckToken({
      token: context.getters.token,
      orderNumber: 0,
    }).then(res => {
      if (res && res.isSuccess && res.data.tokenAccess) {
        context.commit("setToken", res.data.tokenAccess);
        isUseToken = true;
      } else {
        context.commit("clearToken");
      }
    })
    return isUseToken
  },
  async getCheckLicense(context) {
    let status = false;
    await License.CheckLicenseState().then((res) => {
      if (res && res.isSuccess) {
        status = res.isSuccess;

        context.commit("setAuth", status);
        context.commit("setUsage", res.data.usage);
      }
    });
    return status;
  },
  async GetSystemConfig(context) {
    try {
      const res = await SystemConfig.GetSystemConfig();
      if (res && res.isSuccess) {
        context.commit("setConfig", res.data);
      } else {
        throw new Error(res.message || "请求错误");
      }
      return res;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getUIConfig(context) {
    const URI = process.env.NODE_ENV == "development" ? "." : "/mobile";
    let newConfig = {};
    // return new Promise((resolve, reject) => {
    await fetch(URI + "/static/mobileConfig.json")
      .then((data) => data.json())
      .then((res) => {
        const httpConfig = res;
        newConfig = { id: "mobile" };
        for (const key in httpConfig) {
          if (Object.hasOwnProperty.call(httpConfig, key)) {
            if (httpConfig[key] !== "on") {
              newConfig[key] = httpConfig[key];
            }
          }
        }
        context.commit("ADD_CONFIG", newConfig);
      })
      .catch(() => {
        context.commit("ADD_CONFIG", { id: "mobile" });
      });
    return newConfig
  },

  //获取用户设置的默认跳转
  async getUserConfigGoto() {
    const routeObj: any = { name: "Home" };
    await UserLoginRedirectConfig.GetUserConfig().then((res) => {
      const userConfigGoto = res.data;
      switch (userConfigGoto.loginRedirectGoType) {
        case 1:
          //系统报表
          routeObj.name = "Report";
          break;
        case 3:
          if (userConfigGoto.reportId && userConfigGoto.reportId != 0) {
            routeObj.name = "reportView";
            routeObj.params = { reportId: userConfigGoto.reportId };
            routeObj.query = { isDefaultReport: true };
          }
          break;
      }
    });
    return routeObj;
  },

  async getLang(context) {
    const res = await Language.GetLanguageByApp();
    const { language } = res.data;

    if (language) {
      context.commit("setMessages", language);
    }
    return language
  },

  async getCurrentUser({ commit }) {
    await Users.GetCurrentUser().then((res) => {
      if (res && res.isSuccess) {
        commit("setUser", res.data);
        const { userType } = res.data;
        /**获取当前用户的权限，按权限添加路由 */
        const isPortal = userType.some(item => item == 1 || item == 4);
        const isEDC = userType.some(item => item == 2);
        const isBI = userType.some((item) => item == 8); //BI
        commit("setIsPortal", isPortal);
        commit("setIsEDC", isEDC);
        commit("setIsBI", isBI);

      }
    });
  },

  connectSocket({ commit, state }) {
    if (!state.token) return;
    //初始化websocket
    const { protocol, hostname, pathname, port } = window.location;
    const currentPort = port ? ":" + port : "";
    let wsIp = "";
    if (process.env.NODE_ENV == "development") {
      wsIp = baseUrl.split("//")[1];
      // wsIp = "192.168.0.131";
    } else {
      const index = pathname.indexOf("/mobile");
      const queryName = pathname.substring(0, index);
      wsIp = hostname + currentPort + queryName;
    }
    const _ws = protocol == "http:" ? "ws" : "wss";
    const wsUri = `${_ws}://${wsIp}/messagewebsocket/?userId=${state.user.id}&token=${state.mobileToken}&clientType=2`;
    commit("setSocket", new WebSocket(wsUri));
  },

  loaddingAct(context, loading) {
    context.commit("setloadding", loading)
  }
};
export default actions;
